module.exports = {"130273001":"街道","130273003":"庆北","130273004":"三女河","130273101":"老庄子镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130273.json
// module id = 95
// module chunks = 0